import { TEST_SUMMARY_ACTIONS } from '../constants/test-summary.constants';
import { reviewItem } from '../constants/review-item.constants';
import * as immutable from 'immutable';
import { IgenomicsAction } from '../../../core/interfaces/genomics-action.interface';
import { InterpreationSummary } from '../interfaces/interpreation-summary.interface';
import { createFeatureSelector, createSelector } from '@ngrx/store';


export interface ItestSummaryState {
  reviews: immutable.Map<string, any>;
  interpretationSummaries: Array<InterpreationSummary>;
}
export const selectTestSummaryStore = createFeatureSelector<ItestSummaryState>('testSummary');
export const getAllReviews = createSelector(selectTestSummaryStore, (testSummaryState) => testSummaryState.reviews);
export const getInterpretationSummaries = createSelector(selectTestSummaryStore, (testSummaryState) => testSummaryState.interpretationSummaries);

const storeToCache = function (state: ItestSummaryState, userId: string) {
  const key = `uc-${userId}`;
  let storedState = localStorage.getItem(key);
  storedState = storedState ? JSON.parse(storedState) : { };
  Object.assign(storedState, { 'testSummary': state});
  localStorage.setItem(key, JSON.stringify(storedState));
};

const loadFromCache = function (state) {
  const reviews = state && state.testSummary.reviews ? immutable.fromJS(state.testSummary.reviews) : <immutable.Map<string, any>> immutable.Map();
  return { reviews: reviews};
};

const InitTestSummaryState: ItestSummaryState = {
  reviews: <immutable.Map<string, any>> immutable.Map(),
  interpretationSummaries: []
};


export function testSummaryReducer(state: ItestSummaryState = InitTestSummaryState, action: IgenomicsAction): ItestSummaryState {
  switch (action.type) {
    case TEST_SUMMARY_ACTIONS.SET_FINAL:
      return setReview(state, action.payload.id, action.payload.userID, 'finalReview', action.payload.review);
    case TEST_SUMMARY_ACTIONS.SET_ADDENDUM:
      return setReview(state, action.payload.id, action.payload.userID, 'addendumReview', action.payload.review);
    case TEST_SUMMARY_ACTIONS.INIT_REVIEWS:
      state.reviews = state.reviews.delete(action.payload.id);
      state = Object.assign({ }, state);
      storeToCache(state, action.payload.userID);
      return state;
    case TEST_SUMMARY_ACTIONS.SET_STATE:
      return { ...state, ...loadFromCache(action.payload.state)};
    case TEST_SUMMARY_ACTIONS.SET_SUMMARIES:
      // storeToCache?
      return { ...state, interpretationSummaries: action.payload};
    default:
      return state;
  }
}

const setReview = function (state: ItestSummaryState, id: string, userID: string, type: string, review: string = ''): ItestSummaryState {
  let reviews = state.reviews.get(id) || immutable.fromJS(reviewItem);
  reviews = reviews.set(type, review);
  state.reviews = state.reviews.set(id, reviews);
  storeToCache(state, userID);
  return state;
};

